<h2 mat-dialog-title>Propose changes</h2>
<mat-dialog-content>
  <p class="view-subtitle">{{ meeting.title }} &bull; {{ meeting.studentName }}</p>

  <div class="propose-layout">
    <div class="propose-left">
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Meeting length</mat-label>
        <mat-select
          data-testid="duration-select"
          [formControl]="durationForm.controls.durationMinutes"
          (selectionChange)="onDurationChange()"
        >
          @for (d of allowedDurations(); track d) {
            <mat-option [value]="d" [attr.data-testid]="'duration-option-' + d"
              >{{ d }} min</mat-option
            >
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Meeting format</mat-label>
        <mat-select data-testid="meeting-format-select" [formControl]="meetingTypeControl">
          <mat-option value="remote" data-testid="meeting-format-option-remote"
            >Remote (online)</mat-option
          >
          <mat-option value="in-person" data-testid="meeting-format-option-in-person"
            >In person</mat-option
          >
        </mat-select>
      </mat-form-field>

      @if (isCounselor) {
        @if (isInPerson) {
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Location</mat-label>
            <input matInput data-testid="location-input" [formControl]="locationControl" />
          </mat-form-field>
        } @else {
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Meeting Link</mat-label>
            <input
              matInput
              data-testid="meeting-link-input"
              type="url"
              placeholder="https://…"
              [formControl]="meetingLinkControl"
            />
            <mat-hint>Paste the link from your calendar or video app</mat-hint>
          </mat-form-field>
        }
      }

      @if (showMessageField) {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>Message (optional)</mat-label>
          <textarea
            matInput
            data-testid="message-input"
            [formControl]="messageControl"
            rows="4"
            placeholder="Explain why you're proposing this change…"
          ></textarea>
        </mat-form-field>
      }
    </div>

    <div class="propose-right">
      @if (!prefsLoaded()) {
        <div class="calendar-placeholder">
          <mat-icon>hourglass_empty</mat-icon>
          <span>Loading availability…</span>
        </div>
      } @else if (!durationForm.controls.durationMinutes.value) {
        <div class="calendar-placeholder">
          <mat-icon>calendar_month</mat-icon>
          <span>Select a meeting length to see available dates</span>
        </div>
      } @else if (!inDayView) {
        <mat-calendar
          data-testid="propose-calendar"
          [dateFilter]="dateFilter"
          [minDate]="earliestDate"
          [maxDate]="pickerMaxDate"
          [selected]="selectedDate"
          (selectedChange)="onDateSelected($event)"
        />
        @if (selectedDate) {
          <div class="see-times-row">
            <button
              mat-flat-button
              color="primary"
              type="button"
              data-testid="see-times-btn"
              (click)="goToDayView()"
            >
              See available times for {{ selectedDate | date: 'EEE, MMM d' }}
              <mat-icon iconPositionEnd>arrow_forward</mat-icon>
            </button>
          </div>
        }
      } @else {
        <div class="day-view">
          <div class="day-view-header">
            <button
              mat-icon-button
              type="button"
              data-testid="back-to-month-btn"
              (click)="backToMonthView()"
            >
              <mat-icon>arrow_back</mat-icon>
            </button>
            <span class="day-view-title">{{ selectedDate | date: 'EEEE, MMMM d' }}</span>
          </div>
          @if (availableSlots.length) {
            <div class="slots-grid">
              @for (slot of availableSlots; track slot.time.getTime()) {
                <button
                  class="slot-btn"
                  [attr.data-testid]="'slot-btn-' + slot.time.getTime()"
                  [class.selected]="selectedSlot?.getTime() === slot.time.getTime()"
                  [class.blocked]="slot.blocked"
                  [disabled]="slot.blocked"
                  (click)="selectSlot(slot)"
                  type="button"
                >
                  {{ slot.time | date: 'h:mm a' }}
                </button>
              }
            </div>
          } @else {
            <p class="no-slots">No available times on this day.</p>
          }
        </div>
      }
    </div>
  </div>
</mat-dialog-content>
@if (submitError()) {
  <p class="submit-error" data-testid="submit-error">{{ submitError() }}</p>
}
<mat-dialog-actions align="end">
  <button mat-button type="button" data-testid="cancel-propose-btn" (click)="dialogRef.close()">
    Cancel
  </button>
  <button
    mat-flat-button
    color="primary"
    type="button"
    data-testid="submit-propose-btn"
    [disabled]="submitting() || !selectedSlot"
    (click)="submit()"
  >
    {{ submitting() ? 'Sending…' : 'Send proposal' }}
  </button>
</mat-dialog-actions>
